import { SUPPORT_CHAIN_GIFTCARDS } from "utils/wagmi"
import Home from "views/Home"

const IndexPage = () => {
    return <Home/>
}
IndexPage.chains = SUPPORT_CHAIN_GIFTCARDS

export default IndexPage
